import { render } from "./LocalProjects.vue?vue&type=template&id=65d71d45&scoped=true&ts=true"
import script from "./LocalProjects.vue?vue&type=script&lang=ts"
export * from "./LocalProjects.vue?vue&type=script&lang=ts"

import "./LocalProjects.vue?vue&type=style&index=0&id=65d71d45&scoped=true&lang=css"
import "./LocalProjects.vue?vue&type=style&index=1&id=65d71d45&lang=css"

import exportComponent from "/home/bwhite/Projects/bryanchriswhite-com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d71d45"]])

export default __exports__